<template>
	<Container>
		<Subtitle>
			{{ $t('state') }}
		</Subtitle>
		<div class="p-4">
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<div class="mb-4">
						<label class="block mb-2">{{ $t('Nombre') }}</label>
						<input
							type="text"
							v-model="state.name"
							class="
								mt-2
								w-full
								border-t-0
								border-r-0
								border-l-0
								border-b
								border-solid
								border-inputGrey
								outline-none
							"
						/>
						<div v-if="$v.name.$dirty">
							<div class="text-sm text-red-500 mt-2" v-if="!$v.name.required">
								{{ $t('Campo_requerido') }}
							</div>
						</div>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('Pais') }}</label>
					<select
						v-model="state.country_code"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
						id="language"
					>
						<option
							v-for="(country, index) in countries"
							:value="country.code"
							:key="index"
						>
							{{ country.name }}
						</option>
					</select>
					<div v-if="$v.country_code.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.country_code.required"
						>
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('area') }}</label>
					<select
						v-model="state.country_area_id"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
						id="language"
					>
						<option
							v-for="(area, index) in country_areas"
							:value="area.id"
							:key="index"
						>
							{{ area.country_area }}
						</option>
					</select>
					<div v-if="$v.country_area_id.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.country_area_id.required"
						>
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
			</div>

			<div class="flex justify-end">
				<ButtonBlack class="mt-4" @click.native="submit">
					<div v-if="loading">
						<pulse-loader
							:loading="loading"
							:color="'#fff'"
							:size="'10px'"
						></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</Container>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { single } from '@/mixins'
import { fetchState } from '@/apollo/states'
import gql from 'graphql-tag'

export default {
	apollo: {
		state() {
			return this.id !== null ? fetchState(this.id) : null
		},
		countries: gql`
			{
				countries {
					code
					name
				}
			}
		`,
		country_areas: gql`
			{
				country_areas {
					id
					country_area
				}
			}
		`
	},
	data() {
		return {
			state: {
				name: '',
				country_code: null,
				country_area_id: null
			}
		}
	},
	components: {
		PulseLoader
	},
	mixins: [single],
	validations() {
		return {
			name: {
				required,
				maxLength: maxLength(50)
			},
			country_code: {
				required
			},
			country_area_id: {
				required
			}
		}
	},
	methods: {
		submit() {
			this.server_error = ''
			this.buton_text = this.$t('sending')
			this.loading = true
			this.$store.dispatch('isLoading', true)
			this.$v.$touch()
			if (!this.$v.$invalid) {
				this.$apollo
					.mutate({
						mutation: gql`
							mutation insert_states_one($object: states_insert_input!) {
								insert_states_one(object: $object) {
									id
								}
							}
						`,
						variables: {
							object: {
								name: this.name,
								country_code: this.country_code,
								country_area_id: this.country_area_id
							}
						}
					})
					.then(() => {
						this.loading = false
						this.$store.dispatch('isLoading', false)
						this.buton_text = this.$t('sended')
						this.error = false
					})
					.catch(error => {
						this.setError(error)
					})
			} else {
				this.setError(this.$t('form_validation'))
			}
		}
	}
}
</script>
